/**
 * Created by wiki on 2017/2/27.
 */
export const getAppId = state => {
  return state.appid
    ? state.appid
    : ''
}

export const getStores = state => {
  return state.stores
    ? state.stores
    : []
}
export const getUserwx = state => {
  return state.userwx
    ? state.userwx
    : {}
}

export const getGatewayversion = state => {
  return state.gatewayversion
    ? state.gatewayversion
    : []
}
export const getGatewaytype = state => {
  return state.gatewaytype
    ? state.gatewaytype
    : {}
}

export const addmeauDataOnline = state => {
  return state.addmeauDataOnline
    ? state.addmeauDataOnline
    : []
}

export const addmeauDataOpen = state => {
  return state.addmeauDataOpen
    ? state.addmeauDataOpen
    : []
}

export const nameTabs = state => {
  return state.nameTabs
    ? state.nameTabs
    : ''
}

export const searchNumber = state => {
  return state.searchNumber
    ? state.searchNumber
    : ''
}
export const warranty = state => {
  return state.warranty
    ? state.warranty
    : ''
}
export const addmeauDataOnlineRes = state => {
  return state.addmeauDataOnlineRes
    ? state.addmeauDataOnlineRes
    : ''
}
export const addmeauDataOpenRes = state => {
  return state.addmeauDataOpenRes
    ? state.addmeauDataOpenRes
    : ''
}



// WEBPACK FOOTER //
// ./src/store/getters.js